module.exports = __webpack_public_path__ + "img/arrow-right.5af1f587.svg";